<template>
  <div style="height:100%;width:100%;" id="app">
    <router-view ref="routerView" class="router-content"></router-view>
  </div>
</template>

<script>
import GLOBAL from '../../../components/jiri/Global'
import browers from '../../../../plugins/browser.js'
import AppCall from '../../preview/appcall/utils/appcall.js'

window.HBHThat = ''
//获取城市
var cityId = GLOBAL.getCookie('city-id')
if (sessionStorage.getItem('taskCityId')) {
  cityId = sessionStorage.getItem('taskCityId')
}
var authorization = GLOBAL.getCookie('Authorization')
if (sessionStorage.getItem('taskAuthorization')) {
  authorization = sessionStorage.getItem('taskAuthorization')
}

import callapp from 'callapp'

export default {
  cityId,
  authorization,
  beforeMount() {},
  mounted() {
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    if (!/^dmp/.test(authorization)) {
      if (browers().isApp) {
        AppCall.callapp('loginApp', {}, 'location.reload')
      } else {
        GLOBAL.h5Login(location.href)
      }
    } else {
      this.showTask()
    }
  },
  data() {
    return {}
  },

  methods: {
    loginAppCBtask() {
      AppCall.callapp(
        'ui_view_appear',
        'http://fun.test.jiehun.com.cn/task/',
        ''
      )
    },
    showTask() {
      var that = this
      // 如果url中指定了跳转画面,跳转至相应页面
      var url = 'mission.html'
      location.assign(url)
    }
  }
}
</script>

<style>
.router-content {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
